import React from "react";
import ReactDOM from "react-dom";
import { ToolTip } from "../../../components/inputs";
import ModalFooter from "../../../components/modalFooter";
import ModalHeader from "../../../components/modalHeader";
import Td from "../../../components/td";
import { clone, genId, getValue, hideModal, showModal } from "../../../components/utilities";
import "../../../styles/modal.scss";
import "../../../styles/suport.scss";
import { Asset } from "../listAssets";
import ModalAsset from "../modalAsset";
import ModalClass from "../modalClass";
import ModalProfile from "../modalProfile";

class ModalConnection extends React.Component {
  constructor(props) {
    super(props);
    const data = this.handleScheme();
    this.state = {
      _id: "__ModalConnection",
      title: "Conexión",
      show: false,
      old: data,
      data: data,
      change: false,
    };
  }

  handleScheme = (data) => {
    return {
      _id: genId("-1"),
      class_id: this.props.class_id,
      connection_id: "-1",
      code: "",
      class: this.props.class,
      quantity: this.props.quantity || 0,
      required: this.props.required || false,
    };
  };

  handleChangeAsset = (asset) => {
    console.log({ handler: "handleChangeAsset", asset });
    this.setState({
      data: {
        ...this.state.data,
        class_id: getValue(asset, "class_id", "-1"),
        connection_id: getValue(asset, "_id", "-1"),
        code: getValue(asset, "code", ""),
        serie: getValue(asset, "serie", ""),
        rfidcode: getValue(asset, "rfidcode", ""),
        class: getValue(asset, "class", ""),
        equipment: getValue(asset, "equipment", false),
        failure: getValue(asset, "failure", false),
        install: getValue(asset, "install", false),
        preventive: getValue(asset, "preventive", false),
        reported: getValue(asset, "reported", false),
        running: getValue(asset, "running", false),
      },
      change: true,
    });
  };

  handleExecute = (e) => {
    const _state = this.props._state || "0";
    if (typeof this.props.onSetData === "function" && _state === "0") {
      this.props.onSetData(e);
    }
    this.handleHide();
  };

  handleHide = () => {
    hideModal(this.state._id);
    this.setState({ show: false });
  };

  handleShow = () => {
    const _state = this.props._state || "0";
    if (_state === "0") {
      this.setState({ show: true, change: false });
    }
  };

  handleClose = () => {
    if (this.state.change) {
      this.setState({ data: this.state.old, change: false });
    }
    this.handleHide();
  };

  handleOk = () => {
    if (this.state.change) {
      console.log({ handler: "handleOk", data: this.state.data });
      const params = this.state.data;
      this.handleExecute(params);
    } else {
      this.handleHide();
    }
  };

  handleSetData = (e) => {
    this.setState({
      old: e.data,
      data: e.data,
      change: e.change,
    });
    showModal(this.state._id);
  };

  handleRemove = (e) => {
    console.log({ handler: "handleRemove", data: this.state.data });
    if (e) {
      const data = {
        ...this.state.data,
        connection_id: "-1",
        code: "",
        quantity: 0,
      };
      this.handleExecute(data);
    }
  };

  handleData = () => {
    let data = clone(this.props.data);
    this.handleSetData({ data, change: false });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.show) {
      if (prevState.show !== this.state.show) {
        this.handleData();
      }
    }
  }

  render() {
    if (!this.state.show) {
      return (
        <React.Fragment>
          <div
            className={this.props.className}
            onClick={this.handleShow}
            disabled={!(this.props._state === "0" || !this.props._state)}
          >
            {this.props.children}
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div
            className={this.props.className}
            onClick={this.handleShow}
            disabled={!(this.props._state === "0" || !this.props._state)}
          >
            {this.props.children}
          </div>
          {ReactDOM.createPortal(
            <div className="modal fade" id={this.state._id} role="dialog">
              <div className="modal-dialog xs" role="dialog">
                <div className="modal-content">
                  <ModalHeader title={this.state.title} handleClose={this.handleClose} />
                  <div className="modal-body">
                    <div className="modal-box">
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group input-group-sm">
                            <ModalClass
                              className="link"
                              project_id={this.props.project_id}
                              _state={this.props._state}
                              _id={this.state.data.class_id}
                              isFind={true}
                            >
                              Clase
                            </ModalClass>
                            <input className="form-control" value={this.state.data.class} readOnly />
                          </div>
                          <div className="form-group input-group-sm">
                            <ModalAsset
                              className="link"
                              project_id={this.props.project_id}
                              equipment={true}
                              isFind={true}
                              _id={this.state.data.connection_id}
                              onSetData={this.handleChangeAsset}
                            >
                              Equipo
                            </ModalAsset>
                            <Asset
                              className="form-control sp ctr-sm t-m"
                              classNameBtn="input-group-text sp"
                              project_id={this.props.project_id}
                              _state={this.props._state}
                              caption="caption"
                              select={{
                                class_id: this.state.data.class_id,
                                class: this.state.data.class,
                                _id: this.state.data.connection_id,
                                code: this.state.data.code,
                                caption: getValue(this.state.data, "caption", this.state.data.code),
                                unity: getValue(this.state.data, "unity", "und"),
                              }}
                              create={true}
                              onChange={this.handleChangeAsset}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <ModalFooter
                      title="¿Retirar actividad?"
                      description="¿Desea retirar la actividad, sobre el componente? este cambio no podrá revertirse."
                      _state={this.props._state}
                      onRemove={this.handleRemove}
                      onClose={this.handleClose}
                      onOk={this.handleOk}
                    />
                  </div>
                </div>
              </div>
            </div>,
            document.getElementById("rootModals")
          )}
        </React.Fragment>
      );
    }
  }
}

function ComponentConnections(props) {
  const data = props.data || {};
  const list = data.connections || [];
  const handleChange = (e) => {
    props.onChange(e);
  };
  const handleChangeAsset = (e) => {
    const asset = e.asset;
    const item = e.item;
    item.class_id = getValue(asset, "class_id", "-1");
    item.connection_id = getValue(asset, "_id", "-1");
    item.code = getValue(asset, "code", "");
    item.serie = getValue(asset, "serie", "");
    item.rfidcode = getValue(asset, "rfidcode", "");
    item.class = getValue(asset, "class", "");
    item.equipment = getValue(asset, "equipment", false);
    item.failure = getValue(asset, "failure", false);
    item.install = getValue(asset, "install", false);
    item.preventive = getValue(asset, "preventive", false);
    item.reported = getValue(asset, "reported", false);
    item.running = getValue(asset, "running", false);
    props.onChange(item);
  };
  const handleChangeProfile = (e) => {
    props.onChangeProfile(e);
  };

  return (
    <React.Fragment>
      <div className="suport-group mb-4">
        <Td className="suport-head" cols="auto">
          <div className="suport-th">
            Conexiones
            <ModalProfile
              className="link float-right pr-1"
              project_id={props.project_id}
              _id={props.profile_id}
              isFind={true}
              onSetData={handleChangeProfile}
            >
              Perfil
            </ModalProfile>
          </div>
        </Td>
        <Td className="suport-head" cols="auto 75px 74px">
          <div className="suport-th">Clase</div>
          <div className="suport-th">Equipo</div>
          <div className="suport-th">Estatus</div>
        </Td>
        <div className="suport-scroll small" style={{ height: props.height || "413px" }}>
          {list.map((item, i) => {
            return (
              <Td key={i} className="suport-item" cols="auto 75px 70px">
                <div className="suport-td">
                  <ModalConnection
                    className="link"
                    project_id={props.project_id}
                    class_id={item.class_id}
                    class={item.class}
                    _state={props._state}
                    data={item}
                    onSetData={(item) => handleChange(item)}
                  >
                    {item.class}
                  </ModalConnection>
                </div>
                <div className="suport-td t-c">
                  <ModalAsset
                    className="link"
                    isFind={true}
                    project_id={props.project_id}
                    equipment={item.equipment}
                    _id={item.connection_id}
                    data={{
                      project_id: props.project_id,
                      class_id: item.class_id,
                      class: item.class,
                      main_id: data._id,
                      owner_id: data.owner_id,
                      running: data.running,
                      _data: {
                        owner: data._data.owner,
                      },
                    }}
                    onSetData={(asset) => handleChangeAsset({ item, asset })}
                  >
                    {item.code}
                  </ModalAsset>
                </div>
                <div className="suport-td status">
                  <ToolTip className={!item.install ? "fas fa-unlink" : "d-none"} title="Desinstalado" />
                  <ToolTip className={item.failure ? "fas fa-exclamation-triangle" : "d-none"} title="En falla" />
                  <ToolTip
                    className={item.connection_id === "-1" ? "d-none" : item.running ? "fas fa-bolt" : "fas fa-pause"}
                    title={item.connection_id === "-1" ? "" : item.running ? "En funcionamiento" : "En pausa"}
                  />
                  <ToolTip className={item.reported ? "far fa-clipboard" : "d-none"} title="Reportado" />
                  <ToolTip className={item.low ? "fas fa-ban" : "d-none"} title="Dado de baja" />
                  <ToolTip className={item.preventive ? "fas fa-wrench" : "d-none"} title="Mantenimiento preventivo" />
                  <ToolTip className={item.alerts ? "fas fa-exclamation-circle" : "d-none"} title="Alertas" />
                </div>
              </Td>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
}

export default ComponentConnections;
